export default __webpack_public_path__ + "static/media/cancer-connections.8810fe0f.png";